import Vue from "vue";
import "./plugins/axios";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./quasar";
import i18n from "./i18n";
import "@/scss/custom.scss";
import VueGtag from "vue-gtag";
// Vue.use(VueGtag, {
//   config: { id: "G-QDY6XBZV0G" }
// }, router);
Vue.use(
  VueGtag,
  {
    config: { id: process.env.VUE_APP_ANALYTICS_ID },
    pageTrackerTemplate(to) {
      let title = to.name;
      if (title == "Home") {
        title = "Home - Maipú Salud";
      }
      if (title == "Telefonos") {
        title = "Teléfonos - Maipú Salud";
      }
      if (title == "Tramites") {
        title = "Trámites y pagos online - Maipú Salud";
      }
      if (title == "Noticias") {
        title = "Noticias - Maipú Salud";
      }
      if (title == "Publicacion") {
        title = "Maipú Salud";
      }
      if (title == "PublicacionPreview") {
        title = "Noticia Preview";
      }
      if (title == "Categoria") {
        title = "Noticias";
      }
      if (title == "Comuna") {
        title = "Comuna";
      }
      if (title == "Municipalidad") {
        title = "Maipú Salud";
      }
      if (title == "Destacado") {
        title = "Destacado";
      }
      if (title == "Pagina") {
        title = "Maipú Salud";
      }
      if (title == "PaginaPreview") {
        title = "Preview Página";
      }
      if (title == "Contacto") {
        title = "Formulario de Consultas - Maipú Salud";
      }
      if (title == "Concejo") {
        title = "Concejo Municipal - Maipú Salud";
      }
      if (title == "Organizaciones") {
        title = "Ley 21.146 - Maipú Salud";
      }
      if (title == "OfertasOmil") {
        title = "Ofertas Laborales OMIL - Maipú Salud";
      }
      if (title == "QuienesSomos") {
        title = "Quienes Somos - Maipú Salud";
      }
      if (title == "TramitesSalud") {
        title = "Trámites - Maipú Salud";
      }
      if (title == "NuestraRed") {
        title = "Red de Salud - Maipú Salud";
      }
      if (title == "InformacionPaciente") {
        title = "Información al usuario - Maipú Salud";
      }
      if (title == "PrestacionSaludProgramas") {
        title = "Prestaciones de Salud y Programas - Maipú Salud";
      }
      if (title == "InscribeteCesfam") {
        title = "Busca tu Cesfam - Maipú Salud";
      }
      if (to.params.nombre) {
        if (title == "Maipú Salud") {
          title = to.params.nombre.replaceAll("-", " ") + " - " + title;
        } else {
          title = title + " - " + to.params.nombre.replaceAll("-", " ");
        }
      }
      return {
        page_title: title,
        page_path: to.path
      };
    }
  },
  router
);

//Truncate text
var filter = function (text, length, clamp) {
  clamp = clamp || "...";
  var node = document.createElement("div");
  node.innerHTML = text;
  var content = node.textContent;
  if (content) {
    return content.length > length ? content.slice(0, length) + clamp : content;
  } else {
    return text;
  }
};
Vue.filter("truncate", filter);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
